import { CxLocaleService } from '@app/core';

app.filter('i18n', (locale: CxLocaleService) => {
	return (value, args, fallback) => {
		return locale.getString(value, args, fallback);
	};
});
